import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import Col from "react-bootstrap/Col";
import React from "react";
import Form from "react-bootstrap/Form";
import type RefundChargeViewModel from "viewModels/callCenter/search/charges/refundChargeViewModel";
import FuelTypeChangeViewModel from "viewModels/callCenter/search/charges/fuelTypeChangeRefundViewModel";
import { formatDateTime, formatLicensePlate } from "utils/localizations";

export const RefundInformationPanel: ViewComponent<RefundChargeViewModel | FuelTypeChangeViewModel> = observer(({ vm }) => {
  const isFuelTypeChange = vm.secondStep && vm instanceof FuelTypeChangeViewModel;
  let preview = undefined;

  if (vm instanceof FuelTypeChangeViewModel) {
    preview = vm.previewPartialResponse ?? vm.previewFuelTypeResponse;
  }
  if (isFuelTypeChange && preview) {
    return (
      <div className="bg-light mb-4 px-4 pt-4 rounded">
        <Form.Row>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("licensePlate", "licensePlate")}</Form.Label>
            <div>{formatLicensePlate(vm.chargeResponse.vehicle)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("charge", "chargeTypeId")}</Form.Label>
            <div>{vm.translateChargeType(vm.chargeResponse)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translate("variableSymbol")}</Form.Label>
            <div className="text-break">{vm.chargeResponse.orderIdent}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("customerPartialRefundCandidatePreviewResponse", "officialRecordId")}</Form.Label>
            <div className="text-break">{vm.officialRecordId}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("charge", "validSince")}</Form.Label>
            <div className="text-nowrap">{formatDateTime(vm.chargeResponse.validSince)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("charge", "validUntil")}</Form.Label>
            <div className="text-nowrap">{formatDateTime(vm.chargeResponse.validUntil)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("customerPartialRefundCandidatePreviewResponse", "fuelTypeId")}</Form.Label>
            <div>{vm.translateFuelType(vm.chargeResponse)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("customerPartialRefundCandidatePreviewResponse", "_newFuelTypeId")}</Form.Label>
            <div>{vm.translateFuelTypeId(preview.fuelTypeId)}</div>
          </Form.Group>
          {preview.emailAddress && (
            <Form.Group as={Col} xs={12}>
              <Form.Label>{vm.translateAttribute("customerPartialRefundCandidatePreviewResponse", "emailAddress")}</Form.Label>
              <div>{preview.emailAddress}</div>
            </Form.Group>
          )}
        </Form.Row>
      </div>
    );
  }

  return (
    <div className="bg-light mb-4 px-4 pt-4 rounded">
      <Form.Row>
        <Form.Group as={Col} sm={4} xs={6}>
          <Form.Label>{vm.translateAttribute("licensePlate", "licensePlate")}</Form.Label>
          <div>{formatLicensePlate(vm.chargeResponse.vehicle)}</div>
        </Form.Group>
        <Form.Group as={Col} sm={4} xs={6}>
          <Form.Label>{vm.translateAttribute("charge", "chargeTypeId")}</Form.Label>
          <div>{vm.translateChargeType(vm.chargeResponse)}</div>
        </Form.Group>
        <Form.Group as={Col} sm={4} xs={6}>
          <Form.Label>{vm.translate("variableSymbol")}</Form.Label>
          <div className="text-break">{vm.chargeResponse.orderIdent}</div>
        </Form.Group>
        <Form.Group as={Col} sm={4} xs={6}>
          <Form.Label>{vm.translateAttribute("charge", "fuelTypeId")}</Form.Label>
          <div>{vm.translateFuelType(vm.chargeResponse)}</div>
        </Form.Group>
        <Form.Group as={Col} sm={4} xs={6}>
          <Form.Label>{vm.translateAttribute("charge", "validSince")}</Form.Label>
          <div className="text-nowrap">{formatDateTime(vm.chargeResponse.validSince)}</div>
        </Form.Group>
        <Form.Group as={Col} sm={4} xs={6}>
          <Form.Label>{vm.translateAttribute("charge", "validUntil")}</Form.Label>
          <div className="text-nowrap">{formatDateTime(vm.chargeResponse.validUntil)}</div>
        </Form.Group>
      </Form.Row>
    </div>
  );
});

export default RefundInformationPanel;
